import React from 'react';
import { awsRum } from 'Utils/AwsRum';

const fallbackStyle: React.CSSProperties = {
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#ffffff',
  background: 'linear-gradient(0deg, black, #1d2f44)',
  fontFamily: 'Lato, sans-serif',
  fontSize: '16px',
};

export const StartupLoadingScreen = () => <div style={fallbackStyle}>Loading...</div>;

export class StartupErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Startup render error:', error, errorInfo);
    // The boundary catches this before it reaches window.onerror, so RUM never
    // captures it automatically — only this explicit recordError gets it there.
    // Attach the React component stack (without mutating the caught error) so
    // RUM shows which component threw during boot.
    const reportedError = new Error(error.message);
    reportedError.name = error.name;
    reportedError.stack = errorInfo.componentStack
      ? `${error.stack ?? ''}\n\nReact component stack:${errorInfo.componentStack}`
      : error.stack;
    awsRum?.recordError(reportedError);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            ...fallbackStyle,
            padding: '24px',
            textAlign: 'center',
          }}
        >
          MuseFlow could not finish starting. Please close and reopen the app.
        </div>
      );
    }

    return this.props.children;
  }
}
